import { useState } from 'react';
import CommunicationStyleModal from './CommunicationStyleModal';
import ModuleEmptyState from './ModuleEmptyState';
import { PACING_LABELS, HUMOR_LABELS } from '../../content/personaOptions';
import styles from './DashboardModules.module.css';

const getDisplayString = (values, labelMap) => {
  if (!Array.isArray(values) || values.length === 0) {
    return <em>Not set</em>;
  }
  return values.map((val) => labelMap[val] || val).join(', ');
};

const CommunicationStyleModule = ({
  digitalLegacy,
  isComplete,
  isRecommended,
  onSave,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const style = digitalLegacy?.communicationStyle || {};

  return (
    <>
      <div
        className={`${styles.moduleCard} ${isComplete ? styles.completed : ''} ${isRecommended ? styles.recommended : ''}`}
      >
        <div className={styles.moduleHeader}>
          <h5>Communication Style</h5>
          {isComplete ? (
            <span className={`${styles.statusTag} ${styles.complete}`}>
              Complete
            </span>
          ) : (
            <span className={`${styles.statusTag} ${styles.todo}`}>To-Do</span>
          )}
        </div>
        <div className={styles.moduleContent}>
          {isComplete ? (
            <>
              <div className={styles.infoGrid}>
                <div className={styles.infoItem}>
                  <label>Pacing</label>
                  <span className={styles.infoValue}>
                    {getDisplayString(style.pacing, PACING_LABELS)}
                  </span>
                </div>
                <div className={styles.infoItem}>
                  <label>Humor Style</label>
                  <span className={styles.infoValue}>
                    {getDisplayString(style.humorStyle, HUMOR_LABELS)}
                  </span>
                </div>
              </div>
              <button
                onClick={() => setIsModalOpen(true)}
                className={`action-button secondary ${styles.editButton}`}
              >
                Edit Style
              </button>
            </>
          ) : (
            <ModuleEmptyState
              icon="fa-comments"
              text="Define how your AI speaks. This shapes its personality in every conversation."
              buttonText="Add Style"
              onButtonClick={() => setIsModalOpen(true)}
            />
          )}
        </div>
      </div>
      {isModalOpen && (
        <CommunicationStyleModal
          digitalLegacy={digitalLegacy}
          onClose={() => setIsModalOpen(false)}
          onSave={onSave}
        />
      )}
    </>
  );
};

export default CommunicationStyleModule;
